export const capitalizar = (str) => {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ''
}

export const acortarTexto = (str, length = 50) => {
  if (!str) return ''
  return str.length > length ? `${str.slice(0, length).trim()}...` : str
}
